import React from "react";
import { Input, Form } from "antd";
import styles from "./emailInput.scss";
import { requiredField } from "../../../../../../models/formValidator";

const rules = [
  requiredField(null, "Upišite svoj e-mail"),
  {
    type: "email",
    message: "Netočna e-mail adresa"
  },
  {
    max: 254,
    message: "E-mail ne može biti duži od 254 znaka."
  }
];

const EmailInput = ({ form, user, isHidden}) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item style={{ display: isHidden ? "none" : "block" }}>
      {getFieldDecorator("email", {
        rules
      })(
        <Input
          autoComplete="email"
          size="large"
          className={styles.email}
          placeholder={"Unesite e-mail"}
          disabled={user && user.email}
        />
      )}
    </Form.Item>
  );
};

export default EmailInput;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/EmailInput/index.tsx